import { useState, useEffect } from "react";
import axios from "../customAxios.js";
import { Button, CircularProgress, Grid, TextField } from "@mui/material";

import AdapterDateFns from "@mui/lab/AdapterDateFns";
import DatePicker from "@mui/lab/DatePicker";
import MobileDatePicker from "@mui/lab/MobileDatePicker";
import LocalizationProvider from "@mui/lab/LocalizationProvider";
import { es } from "date-fns/locale";

import CustomTable from "../components/CustomTable.jsx";
import { saveAs } from "file-saver";
import { strDateFormat } from "../utils/functions.js";

function Withdrawals2() {
  console.log("Withdrawals2.jsx");
  const [loading, setLoading] = useState(false);
  const [withdrawals, setWithdrawals] = useState([]);
  const [withdrawalsFiltered, setWithdrawalsFiltered] = useState([]);
  const [dateFilter, setDateFilter] = useState(null);

  const fetchWithdrawals = async () => {
    try {
      const { data } = await axios.get("withdrawals/all_withdrawals/");
      setWithdrawals(data);
      setWithdrawalsFiltered(data);
    } catch (error) {
      console.error(`Error al cargar los retiros: ${error}`);
    }
  };
  // ------ NOT USED -------
  const downloadWithdrawals = async () => {
    setLoading(true);
    await axios
      .post(
        "/api/v1/withdrawals/download",
        {},
        { headers: "PENDING!!!!", responseType: "arraybuffer" }
      )
      .then((response) => {
        setLoading(false);
        let file = new File([response.data], "withdrawals.xlsx", {
          type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
        });
        let fileName = "retiros.xlsx";
        saveAs(file, fileName);
      })
      .catch((e) => {
        setLoading(false);
      });
  };

  useEffect(() => {
    fetchWithdrawals();
  }, []);

  //-------------------

  let headerTable = [
    {
      columnName: "Id",
      dbName: "id",
      enabled: true,
    },
    {
      columnName: "Nombre Courier",
      dbName: "courier_name",
      enabled: true,
    },
    {
      columnName: "Nombre Warehouse",
      dbName: "warehouse_name",
      enabled: true,
    },
    { columnName: "Estado", dbName: "status", enabled: true },
    { columnName: "Acciones", dbName: null, enabled: true },
  ];

  // Datepickers not woriking

  return (
    <>
      <Grid item xs={12}>
        <h1>Retiros</h1>
      </Grid>

      <Grid item xs={12} sm className="filters-container">
        <LocalizationProvider dateAdapter={AdapterDateFns} locale={es}>
          {window.innerWidth > 768 ? (
            <DatePicker
              label="Fecha de retiro"
              value={dateFilter}
              onChange={(newValue) => {
                setDateFilter(newValue);
                setWithdrawalsFiltered(
                  newValue === null
                    ? withdrawals
                    : withdrawals.filter(function (a) {
                        return (
                          strDateFormat(new Date(a.withdrawal_date)) ===
                          strDateFormat(newValue)
                        );
                      })
                );
              }}
              renderInput={(params) => <TextField {...params} />}
            />
          ) : (
            <MobileDatePicker
              label="Fecha de retiro"
              value={dateFilter}
              className="custom-mobile-datepicker"
              okText="Aceptar"
              cancelText="Cancelar"
              onChange={(newValue) => {
                setDateFilter(newValue);
                setWithdrawalsFiltered(
                  newValue === null
                    ? withdrawals
                    : withdrawals.filter(function (a) {
                        return (
                          strDateFormat(new Date(a.withdrawal_date)) ===
                          strDateFormat(newValue)
                        );
                      })
                );
              }}
              renderInput={(params) => <TextField {...params} />}
            />
          )}
        </LocalizationProvider>
        <Button
          variant="outlined"
          onClick={() => {
            downloadWithdrawals();
          }}
        >
          {loading ? (
            <CircularProgress className="loading-btn" />
          ) : (
            <>
              <i className="material-icons" style={{ width: "24px" }}>
                download
              </i>
              Exportar Retiros
            </>
          )}
        </Button>
      </Grid>

      <Grid container className="custom-table-container">
        <Grid item xs={12} className="flex-center">
          <CustomTable
            data={withdrawalsFiltered}
            headerTable={headerTable}
            fetchWithdrawals={fetchWithdrawals}
            selected={"none"}
            setSelected={"none"}
            hasPagination={true}
            collapseType={"withdrawals-detail"}
          />
        </Grid>
      </Grid>
    </>
  );
}

export default Withdrawals2;
